import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {ZadImportSuccess} from '../../../models/zad'
import {ZadApiError} from '../zad/errors'
import {importZadCatalog} from './service'
import {ZadImportState} from './types'

const initialState: ZadImportState = {
  actionLoading: false,
  error: null,
  errorCode: null,
  errorStatus: null,
  errors: undefined,
  lastResult: null,
}

function applyRejected(state: ZadImportState, action: PayloadAction<any>) {
  const payload = (action.payload || {}) as ZadApiError
  state.error = payload.error || 'Request failed'
  state.errorCode = payload.errorCode || null
  state.errorStatus = payload.status || null
  state.errors = payload.errors
}

const zadImportSlice = createSlice({
  name: 'zadImport',
  initialState,
  reducers: {
    clearZadImportState: (state: ZadImportState) => {
      state.actionLoading = false
      state.error = null
      state.errorCode = null
      state.errorStatus = null
      state.errors = undefined
      state.lastResult = null
    },
  },
  extraReducers: (builder) => {
    builder.addCase(importZadCatalog.pending, (state: ZadImportState) => {
      state.actionLoading = true
      state.error = null
      state.errorCode = null
      state.errorStatus = null
      state.errors = undefined
      state.lastResult = null
    })
    builder.addCase(importZadCatalog.rejected, (state: ZadImportState, action: PayloadAction<any>) => {
      applyRejected(state, action)
      state.actionLoading = false
    })
    builder.addCase(
      importZadCatalog.fulfilled,
      (state: ZadImportState, action: PayloadAction<ZadImportSuccess>) => {
        state.actionLoading = false
        state.error = null
        state.errorCode = null
        state.errorStatus = null
        state.errors = undefined
        state.lastResult = action.payload
      }
    )
  },
})

export default zadImportSlice.reducer
export const actions = zadImportSlice.actions
export {initialState as zadImportInitialState}
